<template>
  <div>
    <div class="flex flex-wrap justify-between items-center">
      <ProductAverageReview
        v-if="product"
        :rating="product._rating ?? undefined"
        :show-schema="!!product._rating"
      />
      <ProductAttributeWrapper
        v-if="product"
        :product="product"
        class="w-full lg:w-auto"
      />
    </div>
    <ProductTitle :product-title="productTitle" />
  </div>
</template>

<script setup lang="ts">
import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';
import { productGetters } from '~/utils/ct';

defineOptions({ name: 'ProductHeader' });

const props = defineProps<{
  product: ProductVariantExtended;
}>();

const productTitle = computed(() => productGetters.getName(props.product));
</script>
